module.exports = __webpack_public_path__ + "static/template-preview-7189babc2d8eafaeaa081d4145fb03e7.png";